import React, { useState } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import validateAddCategoriesSitePublishers from "../../../../validtions/forms/category-site-publishers/add-categories-site-publishers";
import helperSpinner from "../../../../helpers/spinner";

function AddCategorySitePublisher() {
  const history = useHistory();
  const [message, setMessage] = useState();

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  const sendRequestAddCategorySitePublisher = async (formData) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-site-publishers",
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };
  const sendFormAddCategorySitePublisher = (e) => {
    e.preventDefault();

    const formData = getFormData();

    if (validateAddCategoriesSitePublishers(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateAddCategoriesSitePublishers(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (sendRequestAddCategorySitePublisher(formData)) {
      history.push("/manage/category-publishers/all");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const getFormData = () => {
    return {
      name: document.getElementById("name").value,
    };
  };

  return (
    <>
      <Sidebar openItem="manage-category-publisher-menu" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن دسته سایت نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={sendFormAddCategorySitePublisher}>
                <div className="form-group">
                  <label>نام</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    tabIndex="1"
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  اضافه کردن
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddCategorySitePublisher;
